import React, { FunctionComponent, useRef, useState } from 'react';
import classNames from 'classnames';
import { ForgeIcon, ForgePopover } from '@tylertech/forge-react';
import './index.scss';

interface Props {
  label: string;
  popoverContent: string | JSX.Element;
  popoverIconId: string; // needs to be unique
  // for accessibility, please provide at least one of these two aria props for the popover
  ariaLabelledById?: string; // this is the id for the popover title
  ariaLabel?: string;
  className?: string;
  popoverMaxWidth?: number;
  /**
   * (Default: undefined)
   * String that is the id of the element that this label describes. Highly
   * recommended for max accessibility.
   */
  htmlFor?: string;
}

const LabelWithHelperText: FunctionComponent<Props> = ({
  label,
  popoverContent,
  ariaLabelledById,
  ariaLabel,
  popoverIconId: id,
  className,
  htmlFor,
  popoverMaxWidth = 300
}: Props) => {
  return (
    <div>
      <div className={classNames('label-with-helper', 'forge-typography--heading2', className)}>
        <label className="forge-typography--heading2" {...(htmlFor ? { htmlFor: htmlFor } : {})}>
          {label}
        </label>
        <div className="icon-wrapper">
          <ForgeIcon name="info_outline" className="label-icon" id={id} />
          <ForgePopover
            anchor={id}
            role="dialog"
            triggerType="hover"
            hoverDismissDelay={100}
            {...(ariaLabelledById ? { 'aria-labelledby': ariaLabelledById } : {})}
            {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
          >
            <div
              style={{ width: `${popoverMaxWidth}px`, padding: '8px' }}
              className="forge-typography--body1 body-section"
            >
              {popoverContent}
            </div>
          </ForgePopover>
        </div>
      </div>
    </div>
  );
};

export default LabelWithHelperText;
